<template>
  <li class="mt-4">
    <p
      class="header"
      :class="{ required: required, custom: custom, started: started, [listSign]: true }"
    >
      {{ label }}
      <span
        v-if="!required"
        class="optional-text"
      > {{ $t('message.optional') }}</span>
    </p>
    <slot />
    <p
      v-for="(text, index) in helpText"
      :key="index"
      class="f-14 mt-2 mb-4 font-italic font-weight-regular"
    >
      {{ text }}
    </p>
  </li>
</template>
<script>
export default {
    name: 'SheetQuestion',
    inject: ['$validator'],
    props: {
        label: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        started: {
            type: Boolean,
            default: false
        },
        custom: {
            type: Boolean,
            default: false
        },
        listSign: {
            type: String,
            default: ''
        },
        helpText: {
            type: Array,
            default: () => []
        }
    }
};
</script>
<style lang="scss"></style>
